import { useUpdateEffect } from 'react-use';

import { useLoading } from '@frontend/utils';

export interface UsePullToRefreshOptions {
  operationKey: string;
}

export interface UsePullToRefreshReturn {
  useRegisterUpdate(cb: () => any): void;
  completed(): void;
}

export const usePullToRefresh = ({
  operationKey,
}: UsePullToRefreshOptions): UsePullToRefreshReturn => {
  const { updateKey, addOperationsInProgress, removeOperationsInProgress } =
    useLoading();

  return {
    useRegisterUpdate: (cb) => {
      // biome-ignore lint/correctness/useHookAtTopLevel: this is correct since a hook is generated that then calls the hook here
      useUpdateEffect(() => {
        if (updateKey !== undefined) {
          addOperationsInProgress(operationKey);
          cb();
        }
      }, [updateKey]);
    },
    completed: () => {
      removeOperationsInProgress(operationKey);
    },
  };
};
